import { InViewOptions } from '@/types/track';
import { BusEventKeys } from '@/constants/track';
import { useEffect, useRef, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import Tracker from 'tracks/tracker';

/**
 * @param options 埋点参数
 * 这里组件展示埋点统一使用BusEventKeys.productCardImpression，具体的埋点事件使用trackType区分(具体逻辑函数写在useProductCardImpressionTrack文件中)
 * 整个过程: 发送BusEventKeys.productCardImpression埋点事件 -> 匹配事件函数(useTrack.ts) -> 根据trackType匹配真正的埋点处理函数, 埋点参数均写在
 * options中，在具体的处理函数中自行处理
 *
 * 注意！！！！！！！！！！！！！！！！！！！
 * 即时发送和延迟发送参数不通用，注意设置正确trackType的值
 */
function useProductCardInview(options: InViewOptions, sendNow?: boolean) {
  const { ref, inView, entry } = useInView({
    threshold: 0.5
  });
  const timer = useRef(null);
  const reportRef = useRef<boolean>(false);

  useEffect(() => {
    if (inView) {
      if (reportRef.current) return;
      if (sendNow) {
        timer.current = setTimeout(() => {
          reportRef.current = true;
          const type = options.trackType;
          delete options.trackType;
          new Tracker().addEventPageView(type, options).send();
        }, 1000);
      } else {
        timer.current = setTimeout(() => {
          reportRef.current = true;
          !!options && window.bus.emit(BusEventKeys.productCardImpression, options);
        }, 1000);
      }
    } else {
      clearTimeout(timer.current);
    }
    return () => clearTimeout(timer.current);
  }, [inView, sendNow, options]);

  return { ref, inView, entry };
}

export default useProductCardInview;
